import { EVENT_KEY, TRACKING_ACTION } from 'src/config/tracking/index.js'
import trackingUtils from 'src/config/services/countlyTracking/utils.js'

const adminTracking = {
  trackAdmin (result = 'SUCCESS', failedReason = null) {
    const validEntities = ['ADMIN', 'MEMBER', 'TEACHERS', 'GRADES', 'BOOKABLES', 'SUBJECTS', 'TIMES', 'COURSES', 'HOLIDAYS']
    const validateEntity = (entity) => {
      if (!validEntities.includes(entity)) {
        console.warn(`Unknown entity for admin tracking: ${entity}`)
        return false
      }
      return true
    }
    const action = {
      delete: ({ entity }) => {
        if (!validateEntity(entity)) return
        return trackingUtils.track(EVENT_KEY.ADMIN.ACTION, { action: TRACKING_ACTION[`REMOVE_${entity}`] })
      },
      save: ({ entity }) => {
        if (!validateEntity(entity)) return
        return trackingUtils.track(EVENT_KEY.ADMIN.ACTION, { action: TRACKING_ACTION[`ADD_${entity}`] })
      },
      export: ({ exportObject, fileFormat = null, schoolYear = null }) => trackingUtils.track(EVENT_KEY.ADMIN.ACTION, { action: TRACKING_ACTION.EXPORT, exportObject, fileFormat, schoolYear }),
      removeCourses: () => trackingUtils.track(EVENT_KEY.ADMIN.ACTION, { action: TRACKING_ACTION.REMOVE_COURSES }),
      prepareExport: ({ exportObject, schoolYear }) => trackingUtils.track(EVENT_KEY.ADMIN.ACTION, { action: TRACKING_ACTION.PREPARE_EXPORT, exportObject, schoolYear })
    }
    const interaction = {
    }
    const start = {
      export: () => trackingUtils.track(EVENT_KEY.ADMIN.START, { action: TRACKING_ACTION.EXPORT })
    }
    const end = {
      export: ({ exportObject, fileFormat }) => trackingUtils.trackWithResult(EVENT_KEY.ADMIN.END, { action: TRACKING_ACTION.EXPORT, exportObject, fileFormat, result, failedReason })
    }
    return {
      action,
      interaction,
      start,
      end
    }
  }
}

export default adminTracking
